import DateFnsUtils from "@date-io/date-fns"
import CssBaseline from "@material-ui/core/CssBaseline"
import { ThemeProvider } from "@material-ui/core/styles"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import FlagProvider from "components/FeatureFlag/FlagProvider"
import FlagSyncer from "components/FeatureFlag/FlagSyncer"
import TopProgressBar from "components/TopProgressBar"
import { configure as mobxConfigure } from "mobx"
import { lazy, Suspense } from "react"
import { BrowserRouter as Router } from "react-router-dom"
import { Slide, ToastContainer } from "react-toastify"
import Modals from "singletons/Modals"
import theme from "theming/base"
import { queryClient } from "util/query-client"
import ErrorCatcher from "../ErrorCatcher"
import ModalsContainer from "../ModalsContainer"

import "css/general.css"
import "react-toastify/dist/ReactToastify.css"
import "css/toastify_overrides.css"

const RouterTree = lazy(() => import("./RouterTree"))

if (process.env.NODE_ENV !== "production") {
	mobxConfigure({
		disableErrorBoundaries: true,
	})
}

const HiddenModalOpener = () => (
	<button
		type="button"
		onClick={() => Modals.open("hidstgs")}
		style={{
			position: "fixed",
			bottom: "1em",
			left: "1em",
			width: "1em",
			height: "1em",
			background: "red",
			zIndex: 100000,
			border: "none",
			padding: 0,
			cursor: "pointer",
		}}
		aria-label="Open hidden settings"
	/>
)

const App = () => (
	<QueryClientProvider client={queryClient}>
		<ReactQueryDevtools initialIsOpen={false} />
		<FlagProvider>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{process.env.REACT_APP_ENVIRONMENT !== "production" ? (
					<HiddenModalOpener />
				) : null}
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<Router>
						<ErrorCatcher>
							<Suspense fallback="Loading app...">
								<RouterTree />
							</Suspense>
							<ModalsContainer />
							<ToastContainer position="bottom-left" transition={Slide} />
						</ErrorCatcher>
					</Router>
				</MuiPickersUtilsProvider>
				<TopProgressBar />
				<FlagSyncer />
			</ThemeProvider>
		</FlagProvider>
	</QueryClientProvider>
)

export default App
